import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, FormControl, Button } from 'react-bootstrap';
import couponsAPI from '../../../../_api/coupons';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { deleteCartCoupon, setCartCoupon } from '../../../actions/cart';


class CouponForm extends React.Component {
  static propTypes = {
    coupon: PropTypes.object,
    offerType: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      showCouponFiled: false,
      couponList: [],
    };
  }

  componentDidMount() { this.loadListFromServer() };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.offerType !== this.props.offerType){
      this.loadListFromServer();
      // если текущий купон существует и подходит списку продуктов - оставляем как есть
      // иначе очищаем
      if (this.props.coupon &&
          this.props.coupon.shopoffers_type &&
          this.props.coupon.shopoffers_type !== this.props.offerType){
            this.resetCoupon(this.state.showCouponFiled);
      }
    }
  }

  loadListFromServer = async () => {
    const response = await couponsAPI.getAvailableList(this.props.id, this.props.offerType)
    if (response) this.setState({ couponList: response })
  }

  resetCoupon = (showCouponFiled=false) => {
    this.setState({ showCouponFiled: showCouponFiled });
    if (this.props.coupon) this.props.deleteCartCoupon();
    if (this.props.input.value)  this.props.input.onChange('');
  };

  handleCheckboxChange = (event) => { this.resetCoupon(event.currentTarget.checked); };

  handleLinkClick = (event) => {
    event.preventDefault();
    let id = parseInt(event.currentTarget.getAttribute('data-id'));
    let coupon = this.state.couponList.filter(item => item.id === id)[0];
    this.props.input.onChange(coupon.code);
    this.props.setCartCoupon(coupon);
  };

  render() {
    let { input, meta} = this.props;
    const coupons = this.state.couponList.map(item => <a href='#' className='mr-2' data-id={ item.id }
                                                         onClick={ this.handleLinkClick }>{ item.code }</a>);
    let checkButtonVariant = 'outline-secondary';
    if (this.props.coupon) checkButtonVariant = 'outline-success';
    else if (meta.touched && meta.invalid) checkButtonVariant = 'outline-danger';

    return (<>
      <Form.Group controlId="formCheckbox">
        <Form.Check type="checkbox" label={ gettext('У меня есть промокод') } onChange={ this.handleCheckboxChange }/>
      </Form.Group>
      { this.state.showCouponFiled && <>
        <InputGroup>
          <FormControl
            placeholder={ gettext('Промокод') }
            aria-label={ gettext('Промокод') }
            aria-describedby="coupon-addon"
            {...input}
            isValid={ this.props.coupon }
            isInvalid={ (meta.touched && meta.invalid) }
          />
          <InputGroup.Append>
            <Button variant={ checkButtonVariant }
                    isValid={ this.props.coupon }
                    isInvalid={ (meta.touched && meta.invalid) }>
              { gettext('Проверить') }
            </Button>
          </InputGroup.Append>
        </InputGroup>
        { coupons.length > 0 && <p className='small my-1'>{ coupons }</p> }
        <Form.Text className="text-muted">
          { gettext('Наши промокоды вы можете найти в наших рассылках, на наших страницах в социальных сетях, а также у партнеров.') }
        </Form.Text>
        { meta.error &&
          <Form.Text className="text-danger">
            { gettext('Неверный код.') } { meta.error }
          </Form.Text>}
        { this.props.coupon &&
          <Form.Text className="text-success">
            { gettext('Ваш промокод верен.')} { gettext('Скидка по промокоду:') } { this.props.coupon.display_value }
          </Form.Text> }
      </> }
      </>
    );
  }
}

export default compose(
  connect(null, { setCartCoupon, deleteCartCoupon }),
)(CouponForm)

